import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
import { heroMicrocopy, productMockup } from '../data/content';
export function Hero() {
  return <header className="flex min-h-[calc(100svh-72px)] w-full flex-col justify-center bg-cream px-5 py-8" data-id="element-123" data-mp="9luyujz7c3so">
      <div className="mx-auto flex w-full max-w-[580px] flex-col items-center text-center" data-id="element-124" data-mp="4n1kkpc3c8rg">
        <Reveal data-id="element-125" data-mp="128frrovbsnyc">
          <p className="text-[10px] font-bold uppercase tracking-[0.18em] text-red" data-id="element-126" data-mp="128z0cez35zzp">
            Til frivillige ungdomstrænere i danske håndboldklubber
          </p>
        </Reveal>

        <Reveal delay={0.06} data-id="element-127" data-mp="s9zz3hgnh6mq">
          <h1 className="mx-auto mt-3 max-w-[520px] font-display text-[29px] font-bold leading-[1.05] tracking-tight text-navy sm:text-[35px]" data-id="element-128" data-mp="sde3ev8vjpwt">
            Træn en hel sæson håndbold på{' '}
            <span className="font-serif text-[0.95em] italic text-red" data-id="element-129" data-mp="3d2tqpg8vwwhp">ti minutters</span>{' '}
            forberedelse om ugen
          </h1>
        </Reveal>

        <Reveal delay={0.12} data-id="element-130" data-mp="3j897ze322dq2">
          <p className="mx-auto mt-3 max-w-[480px] text-sm leading-snug text-muted sm:text-[15px]" data-id="element-131" data-mp="3j924lm8avmuh">
            36 uger, der allerede er lagt. 144 færdige træningspas fra U6 til U19. Du
            åbner PDF'en, læser ti minutter, og går i hallen.
          </p>
        </Reveal>

        <Reveal delay={0.18} className="w-full" data-id="element-132" data-mp="3e8ehvcr3ts62">
          <img src={productMockup} alt="Håndboldklar — seks bind og fem bonusser" className="mx-auto mt-5 w-full max-w-[230px] object-contain drop-shadow-[0_16px_30px_rgba(11,37,69,0.18)] sm:max-w-[270px]" data-id="element-133" data-mp="3eb8x8pv9gmsm" />
        </Reveal>

        <Reveal delay={0.22} className="w-full max-w-[380px]" data-id="element-134" data-mp="2qlog8cio3zlz">
          <div className="mt-5 w-full" data-id="element-135" data-mp="2vi55ja1lsk0n">
            <CtaButton label="Hent hele samlingen — 249 kr." data-id="element-136" data-mp="2vj7sx7zpw4bt" />
          </div>
        </Reveal>

        <Reveal delay={0.26} data-id="element-137" data-mp="2hjyof5kviyno">
          <ul className="mx-auto mt-3.5 flex max-w-[480px] flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[13px] font-medium text-muted" data-id="element-138" data-mp="2lkqxnytqx3jy">
            {heroMicrocopy.map(item => <li key={item} className="flex items-center gap-1.5 whitespace-nowrap" data-id="element-139" data-mp="nbbc4wdi0748">
                <CheckIcon className="h-3.5 w-3.5 shrink-0 text-green" aria-hidden="true" data-id="element-140" data-mp="n9i4bdr5fgun" />
                {item}
              </li>)}
          </ul>
        </Reveal>
      </div>
    </header>;
}